import { observable, action } from "mobx";

import Api from "../config/api";
import string from '../utils/string'
import BaseStore from "./Base.store";


const defaultPageableDTO = {
  pageNumber: 0,
  pageSize: 20,
  sortDir: "ASC",
  sortField: "produto"
};

const defaultMedicamento = {
  id: null,
  produto: "",
  formaFarmaceutica: "",
  principioAtivo: "",
  ativo: true
}

const defaultSearch = "";

export default class MedicamentoPersonalizadoStore extends BaseStore {
  usuarioStore = null;

  @observable last = false;
  @observable loading = true;

  @observable search = defaultSearch;
  @observable pageableDTO = {
    ...defaultPageableDTO
  };

  @observable elements = [];

  @observable open = false;
  @observable idOpened;
  
  @observable medicamento = {
    ...defaultMedicamento
  };
  @observable ativoValue = true;

  @action closeModal() {
      this.open = false;
      this.medicamento = {
        ...defaultMedicamento
      };
  }

  @action clearList() {
    this.elements = [];
    this.pageableDTO.pageNumber = 0;
  }

  @action async findAllMedicamentoPersonalizado(pageableDTO = {}) {
    try {      
      const pageable = {
        ...this.pageableDTO,
        ...pageableDTO
      };

      this.loading = true;

      const response = await Api.post("", {
          query: `
          query ($pageable: PageableDTOInput, $search: String, $ativo: Boolean) {
              findAllMedicamentoProfissionalSaudeAtual(pageableDTO: $pageable, search: $search, ativo: $ativo) {
                last
                content {
                  id
                  produto
                  formaFarmaceutica
                  principioAtivo
                  ativo
                }
            }
          }`,
          variables: {
              pageable: {
                  ...defaultPageableDTO,
                  ...pageable
              },
              search: this.search || defaultSearch,
              ativo: this.ativoValue,
          }
      });

      this.pageableDTO = {
        ...defaultPageableDTO,
        ...pageable
      };

      const { last, content } = response.data.data.findAllMedicamentoProfissionalSaudeAtual;

      this.last = last;

      if (this.pageableDTO.pageNumber > 0) {
        this.elements = [...this.elements, ...content];
      } else {
        this.elements = [...content];
      }
     
    } catch (error) {
      throw error;
    } finally {
      this.loading = false;
    }
  }

  @action async loadById(id) {
    try {
      this.idOpened = id;

      const response = await Api.post("", {
          query: `
          query ($id: UUID) {
            findByIdMedicamento(id: $id) {
                id
                produto
                formaFarmaceutica
                principioAtivo
                ativo
            }
          }
                `,
          variables: {
              id: this.idOpened
          }
      });

      const medicamento = response.data.data.findByIdMedicamento;

      this.medicamento = {...medicamento};
      this.open = true;
     
    } catch (error) {
      throw error;
    } finally {
      this.loading = false;
    }
  }

  @action edit(id) {
    this.loadById(id);
  }

  @action openNew() {
    this.open = true;
    this.medicamento = {...defaultMedicamento};
  }

  @action async create() {
    const {id, ...newMedicamento} = this.medicamento;
    const queryCreate = `
      mutation ($medicamento: MedicamentoInput) {
        createMedicamento(medicamento: $medicamento) {
            id
        }
      }
    `;

    await this.save(queryCreate, newMedicamento);
  }

  @action async update() {
      const updatedMedicamento = {...this.medicamento};
      const queryUpdate = `
        mutation ($medicamento: MedicamentoInput) {
          updateMedicamento(medicamento: $medicamento) {
              id
          }
        }
      `;

      await this.save(queryUpdate, updatedMedicamento);
  }
  
  async save(query, medicamento) {
    try {
      if (string.isEmpty(medicamento.produto)) {
        throw new Error('Preencha os dados');
      }
      
      return Api.post("", {
        query,
        variables: { medicamento }
      });
    } catch (error) {
      throw error;
    }
  }
}
